module.exports = __webpack_public_path__ + "img/NEW PRODUCT.9877d44e.png";